<a class="fake-link" (click)="editing.set(!editing())">
  <ng-content />
</a>
@if (editing()) {
  <span class="inline-select">
    <select #inlineSelect
            [value]="value()"
            (change)="save(inlineSelect)">
      <ng-content select="option" />
    </select>&nbsp;
  </span>
} @else if (acting()) {
  <app-loading [inline]="true" />
}
